export default __webpack_public_path__ + "static/media/user1.d31d5aff.svg";